import axios from 'axios';
import { History } from 'history';
import AuthService from './authService';
import { CustomAxiosRequestConfig } from '../interfaces/axiosInterfaces';
import { publicRoutes } from '../routes/appRouteList';

const isInterceptorEnabled = (config: CustomAxiosRequestConfig = {}): boolean | undefined => {
    return config.isInterceptorEnabled;
};

const notLoggedInError = 'User is not logged in';

const httpService = {
    // we pass the history in order to navigate to the root or the not authorized page
    // if the user is not authenticated or a 401 is returned from a service
    setupInterceptors: (history: History<any>): void => {
        axios.interceptors.request.use(async (request: CustomAxiosRequestConfig) => {
            const newRequest = request;
            const accessToken = await AuthService.getAccessToken();

            if (accessToken) { // The user is authenticated
                let headers: any = {
                    Accept: 'application/json'
                };
                headers = {
                    ...headers,
                    Authorization: `Bearer ${accessToken}`
                };

                newRequest.headers = headers;
                return newRequest;
            }

            // If user is not authenticated, throw a new error for the response below to catch
            return Promise.reject(new Error(notLoggedInError));
        }, (error) => {
            // if any errors occur as part of the request interceptor, we will just go to the not authorized page
            history.push(publicRoutes.notAuthorized);
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            // simply return the response if there is no error
            return response;
        }, (error) => {
            // first check to make sure we should go through the error handling
            if (isInterceptorEnabled(error.config)) {
                // if the error contains the string from the request interceptor above, then redirect to the login page to re-authenticate
                if (error.toString().includes(notLoggedInError) === true) {
                    history.push(publicRoutes.root);
                }

                // if any of the service calls returns a 401, redirect to the not authorized page
                if (error.response.status === 401) {
                    // send the user to the not authorized page since the user/token is not valid
                    history.push(publicRoutes.notAuthorized);
                }
            }

            // just let the calling action handle the error instead if the handler is not enabled
            return Promise.reject(error);
        });
    }
};

export default httpService;
